import styled from 'styled-components';
import { spaceS } from '@xingternal/tokens';
// *** Components ***
export const Container = styled.div `
  display: flex;
  gap: ${spaceS};
  flex-shrink: 0;
`;
//# sourceMappingURL=skeleton-content-switcher.styles.js.map